import { Translation } from "i18n/config";
import * as React from "react";
import { ForgotPasswordTranslation } from "./typing";

export const ForgotPasswordTexts: Translation<ForgotPasswordTranslation> = {
	es: {
		checkYourEmail: "Revisa si has recibido un mail con los pasos correctos para restaurar tu contraseña.",
		thereWasAnError:
			"Disculpe las molestias, hubo un error desde nuestros servidores, considere reenviar el formulario de nuevo mas tarde.",
		recoverPassword: "Recuperar Contraseña",
		findYourVinglet: "Recupera tu cuenta de Vinglet",
		yourQueryWasSent: "Tu peticion ha sido enviada",
		succesfullProcess: () => {
			return (
				<p>
					En breve recibira un email especificando los pasos a seguir para continuar con la recuperacion de su cuenta.
				</p>
			);
		},
		emptyFields: "Hay algunos campos todavia incompletos o mal ingresados.",
		backToTheLogin: "Volver al Login",
		continue: "Continuar",
	},
	en: {
		checkYourEmail: "Check you have received an email with correct step to recover your password.",
		thereWasAnError: "Sorry, there was an error from our server side, please consider try again later.",
		recoverPassword: "Recover Password",
		findYourVinglet: "Find your Vinglet&#39;s account.",
		yourQueryWasSent: "Your query was sent",
		succesfullProcess: () => {
			return (
				<p>
					As soon as possible you will receive an email specifying the properly steps to follow in order to continue
					with the account recovery.
				</p>
			);
		},
		emptyFields: "There are empty o wrongly inserted fields yet.",
		backToTheLogin: "Back to the Login",
		continue: "Continue",
	},
	ca: {
		checkYourEmail: "Revisa si has recibido un mail con los pasos correctos para restaurar tu contraseña.",
		thereWasAnError:
			"Disculpe las molestias, hubo un error desde nuestros servidores, considere reenviar el formulario de nuevo mas tarde.",
		recoverPassword: "Recuperar Contraseña",
		findYourVinglet: "Recupera tu cuenta de Vinglet",
		yourQueryWasSent: "Tu peticion ha sido enviada",
		succesfullProcess: () => {
			return (
				<p>
					En breve recibira un email especificando los pasos a seguir para continuar con la recuperacion de su cuenta.
				</p>
			);
		},
		emptyFields: "Hay algunos campos todavia incompletos o mal ingresados.",
		backToTheLogin: "Volver al Login",
		continue: "Continuar",
	},
	pt: {
		checkYourEmail: "Verifique se você recebeu um e-mail com as etapas corretas para restaurar sua senha.",
		thereWasAnError:
			"Desculpe pelo inconveniente, houve um erro de nossos servidores, considere reenviar o formulário novamente mais tarde.",
		recoverPassword: "Recuperar senha",
		findYourVinglet: "Recupere sua conta Vinglet",
		yourQueryWasSent: "Sua solicitação foi enviada",
		succesfullProcess: () => {
			return (
				<p>
					Você receberá um e-mail em breve especificando as etapas a seguir para continue com a recuperação da sua conta
				</p>
			);
		},
		emptyFields: "Existem alguns campos ainda incompletos ou inseridos incorretamente.",
		backToTheLogin: "Volte ao login",
		continue: "Continuar",
	},
};
